import { get, post, patch } from "./apiService";
import { isNTMSUSer, isAccountAdmin, isAccountUser } from '../utils/roleUtils';

export const fetchCustomers = async () => {
  return get({ path: 'Customer' });
}

export const fetchCustomersFiltered = async (accountId) => {
  return get({ path: `Customer/filtered` });
}

export const addCustomer = async (payload, keepAlive = false) => {
  return post({ path: 'Customer', body: payload, keepAlive: keepAlive });
}

export const updateCustomer = async (payload, keepAlive = false) => {
  return patch({ path: `Customer/${payload.customerId}`, body: payload, keepAlive: keepAlive });
}

export const fetchCustomersByAccount = async (userType, selectedAccountId, accountId, ) => {
  if (isNTMSUSer(userType)) {
    return selectedAccountId === null ? await fetchCustomersFiltered(accountId) : await fetchCustomersFiltered(selectedAccountId);
  }

  if (isAccountAdmin(userType) || isAccountUser(userType)) {
    return fetchCustomersFiltered(accountId);
  }
  
  return await fetchCustomers();
}